import { Popconfirm, Row } from "antd";
import { h } from "preact"
import { useSelector } from "react-redux";
import { Text } from "../../text";
import { useLogout } from "./hook/useLogout";
import { ButtonLogout, StyledLayoutHeader, TextLogo } from "./styled";

interface IUserState {
    dplusID?: string;
    email?: string;
    fullName?: string;
    loginDate?: string;
    role?: string;
}

const LayoutHeader = () => {
    const { dispatchLogout } = useLogout();
    const userState: IUserState = useSelector((state: IAuthState) => state.auth.user);

    return <StyledLayoutHeader>
        <TextLogo>HYDROPLUS ECOSYSTEM</TextLogo>
        <Row align="middle">
            <Text size={"L"} text={`ยินดีต้อนรับ: ${userState.fullName}`} color={'#FFFFFF'} bold={true} />
            <Popconfirm
                placement="bottomRight"
                title={"คุณต้องการออกจากระบบ"}
                onConfirm={() => dispatchLogout()}
                okText="ออกจากระบบ"
                cancelText="ยกเลิก"
            >
                <ButtonLogout />
            </Popconfirm>
        </Row>
    </StyledLayoutHeader>
}

export default LayoutHeader